import { useEffect, useState } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { appErrorText } from "../shared/i18n/appErrorText";
import { reloadOnceForStaleChunk, isStaleChunkError } from "../shared/lib/staleChunk";

/**
 * The router's error screen (batch 13): never the raw "Unexpected Application Error!". A screen file from an older build
 * (after a deploy) reloads the page once by itself; if that did not help, or for any other error, it says what happened in
 * words with a Reload button.
 */
export function RouteError() {
  const error = useRouteError();
  const stale = isStaleChunkError(error);
  const [reloading, setReloading] = useState(stale);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (stale && !reloadOnceForStaleChunk()) setReloading(false);
  }, [stale]);

  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : String(error);
  return (
    <main id="main" className="gf-routeerror pad" role="alert">
      <h1>{stale ? appErrorText("newVersionTitle") : appErrorText("errorTitle")}</h1>
      <p>{stale ? (reloading ? appErrorText("newVersionReloading") : appErrorText("newVersionBody")) : appErrorText("errorBody")}</p>
      <p>
        <button type="button" className="btn" onClick={() => window.location.reload()}>
          {appErrorText("reload")}
        </button>
      </p>
      {!stale && (
        <details>
          <summary>{appErrorText("details")}</summary>
          <pre className="help">{detail}</pre>
        </details>
      )}
    </main>
  );
}
